import useRenderOptions from "./useRenderOptions";
import parse from "html-react-parser";

const RenderOptions = ({
  data,
  state,
  correctAns,
  handleOptionSelect,
  examMode,
}) => {
  const { options, solutionInfo, handleOption } = useRenderOptions({
    data,
    handleOptionSelect,
    examMode,
  });

  return (
    <>
      <ul className="space-y-2">
        {options?.map((option) => (
          <li
            key={option.id}
            className={`flex items-center px-4 py-2 rounded-lg cursor-pointer ${
              correctAns?.[data?.objectId] &&
              correctAns[data?.objectId] == option.id
                ? "bg-green-300"
                : correctAns[data?.objectId] &&
                  state?.[data?.objectId] == option.id
                ? "bg-red-300"
                : "bg-white"
            }`}
          >
            <input
              type="radio"
              id={`options${data?.objectId}${option.id}`}
              name={`options${data?.objectId}`}
              className="mr-2 cursor-pointer"
              checked={state?.[data?.objectId] === option.id}
              onChange={() =>
                correctAns[data?.objectId]
                  ? () => {}
                  : handleOption(option.id, data?.objectId)
              }
            />
            <label
              htmlFor={`options${data?.objectId}${option.id}`}
              className="cursor-pointer"
            >
              {option.id})&nbsp; {parse(option.text || "")}
            </label>
            {(examMode === "false" || !examMode) && (
              <>
                {state?.[data?.objectId] == option.id &&
                  correctAns[data?.objectId] != option.id && (
                    <span className="text-red-500 ml-2 font-bold">
                      &#10005;
                    </span>
                  )}
                {correctAns[data?.objectId] == option.id && (
                  <span className="text-green-500 ml-2 font-bold">
                    &#10003;
                  </span>
                )}
              </>
            )}
          </li>
        ))}
      </ul>
      {solutionInfo && (
        <div className="bg-green-300 p-6 my-6 border border-green-400 rounded-md flex flex-col gap-4">
          <span className="font-bold">Reference:</span>
          <div className="text-sm">{parse(solutionInfo || "")}</div>
        </div>
      )}
    </>
  );
};

export default RenderOptions;
